<script>
export default {
  name: 'SnackBar',
  props: {
    snackbar: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <v-snackbar
    :value="snackbar.snackbar"
    :color="snackbar.color"
    :multi-line="snackbar.mode === 'multi-line'"
    :timeout="snackbar.timeout"
    :vertical="snackbar.mode === 'vertical'"
    @input="$emit('update:snackbar', { ...snackbar, snackbar: $event })"
  >
    {{ snackbar.text }}
    <v-btn
      dark
      flat
      @click="snackbar = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>



// WEBPACK FOOTER //
// src/components/schedules/SnackBar.vue